var heading_default = {
  "fontElementMap": "_6RCIo",
  "elementSpacing": "R3umH",
  "headerOne": "_7-y98 R3umH",
  "headerTwo": "FZJJR R3umH",
  "headerThree": "G6NXy R3umH",
  "headerFour": "_9RbZA R3umH",
  "headerFive": "jI3iZ R3umH",
  "headerSix": "DXfDp R3umH",
  "child": "bGkLU"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
